import { Player } from '../types/models';

const slugifyName = (name: string): string => {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/[\s-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const buildPlayerSlug = (player: Player): string => {
  const slug = slugifyName(player.name || '');
  if (slug) return slug;
  return `player-${player.id}`;
};

export const matchesPlayerSlug = (player: Player, slug: string): boolean => {
  return buildPlayerSlug(player) === slug;
};
